// Memory of how a list/datasheet page was left — view, search, filters, sort, selected record —
// keyed by the BROWSER HISTORY ENTRY (React Router's location.key), not by the page.
//
// That is the whole behaviour: Back/Forward returns to the same entry, so its state comes back;
// the nav tree, a new link or a new tab is a new entry, so the page starts clean. (Keying by page
// restored stale filters on a plain nav click — someone would one day "lose" a record behind a
// filter they forgot they set.) A refresh keeps its entry and so its state.
//
// sessionStorage: per tab, gone when the tab closes. Every access is wrapped — storage can be
// blocked or full, and losing the memory must never break the page.

const PREFIX = 'dawn.view.';

/** Build a key from its parts. */
export const viewMemoryKey = (...parts) => PREFIX + parts.filter(p => p !== undefined && p !== null && p !== '').join(':');

/** Key for one page's state within one history entry, e.g. entryMemoryKey(location, 'task-log'). */
export const entryMemoryKey = (location, ...parts) => viewMemoryKey('entry', location?.key || 'default', ...parts);

export const loadView = (key) => {
  if (!key) return null;
  try {
    const raw = window.sessionStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const saveView = (key, state) => {
  if (!key) return;
  try {
    window.sessionStorage.setItem(key, JSON.stringify(state));
  } catch { /* storage blocked or full — the page works without memory */ }
};
